module.exports = __webpack_public_path__ + "img/ic_inbox.230ea7a6.svg";